<template>
  <Nav />
  <div class="container">
    <div class="audit-container">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1>Auditoria</h1>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <button class="nav-link" :class="{ active: abaAtiva === 'acessos' }" @click="trocarAba('acessos')">
            Acessos
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" :class="{ active: abaAtiva === 'relatorios' }" @click="trocarAba('relatorios')">
            Exportação de Relatórios
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" :class="{ active: abaAtiva === 'balancetes' }" @click="trocarAba('balancetes')">
            Exportação de Balancetes
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" :class="{ active: abaAtiva === 'uploads' }" @click="trocarAba('uploads')">
            Uploads
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link" :class="{ active: abaAtiva === 'usuarios-contextos' }" @click="trocarAba('usuarios-contextos')">
            Logins
          </button>
        </li>
      </ul>

      <!-- Filtros -->
      <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
        <input
          v-if="userAdmin"
          type="text"
          class="form-control filtro-email"
          placeholder="Email do usuário"
          v-model="filtros.email"
          @keyup.enter="buscar"
        />
        <input
          type="text"
          class="form-control filtro-municipio"
          placeholder="Município"
          v-model="filtros.municipio"
          @keyup.enter="buscar"
        />
        <select v-if="['relatorios', 'acessos'].includes(abaAtiva)" class="form-select filtro-tipo" v-model="filtros.tipo" @change="buscar">
          <option value="">Todos os tipos</option>
          <option value="SICONFI">SICONFI</option>
          <option value="CAPAG">CAPAG</option>
          <option v-if="abaAtiva === 'acessos'" value="BALANCETE">BALANCETE</option>
        </select>
        <input type="date" class="form-control filtro-data" v-model="filtros.de" />
        <input type="date" class="form-control filtro-data" v-model="filtros.ate" />
        <button class="btn btn-secondary" @click="buscar" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
          Buscar
        </button>
        <button class="btn btn-secondary" @click="exportarCsv" :disabled="isExporting || logs.length === 0">
          <i class="bi bi-download"></i> Exportar
        </button>
        <button class="btn btn-outline-secondary" @click="limparFiltros" :disabled="loading">Limpar</button>
      </div>

      <!-- Tabela Relatórios -->
      <div v-if="abaAtiva === 'relatorios'">
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <colgroup>
              <col style="width: 10%">
              <col style="width: 20%">
              <col style="width: 25%">
              <col style="width: 10%">
              <col style="width: 10%">
              <col style="width: 25%">
            </colgroup>
            <thead class="table-light">
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Município</th>
                <th>Exercício</th>
                <th>Tipo</th>
                <th>Meses</th>
                <!-- <th>Status</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" class="text-center text-muted py-3">Carregando...</td>
              </tr>
              <tr v-else-if="logs.length === 0">
                <td colspan="9" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-nowrap">{{ formatarData(log.data_evento) }}</td>
                <td>{{ log.email_usuario }}</td>
                <td>{{ log.nome_municipio }}</td>
                <td>{{ log.exercicio }}</td>
                <td>
                  <span class="badge" :class="log.tipo_relatorio === 'CAPAG' ? 'bg-primary' : 'bg-secondary'">
                    {{ log.tipo_relatorio === 'SICONFI' ? 'RANKING' : 'CAPAG' }}
                  </span>
                </td>
                <td>{{ parsarArray(log.meses_selecionados).join(', ') }}</td>
                <!-- <td>
                  <span class="badge" :class="log.status === 'sucesso' ? 'bg-success' : 'bg-danger'">
                    {{ log.status }}
                  </span>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Tabela Balancetes -->
      <div v-if="abaAtiva === 'balancetes'">
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <colgroup>
              <col style="width: 10%">
              <col style="width: 20%">
              <col style="width: 25%">
              <col style="width: 10%">
              <col style="width: 10%">
              <col style="width: 10%">
            </colgroup>
            <thead class="table-light">
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Município</th>
                <th>Exercício</th>
                <th>Mês</th>
                <th>Filtros</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="6" class="text-center text-muted py-3">Carregando...</td>
              </tr>
              <tr v-else-if="logs.length === 0">
                <td colspan="6" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-nowrap">{{ formatarData(log.data_evento) }}</td>
                <td>{{ log.email_usuario }}</td>
                <td>{{ log.nome_municipio }}</td>
                <td>{{ log.exercicio }}</td>
                <td>{{ log.mes ?? '-' }}</td>
                <td>
                  <span class="badge" :class="log.filtros_aplicados ? 'bg-warning text-dark' : 'bg-light text-dark border'">
                    {{ log.filtros_aplicados ? 'Sim' : 'Não' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Tabela Logins -->
      <div v-if="abaAtiva === 'usuarios-contextos'">
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <thead class="table-light">
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Município</th>
                <th>Cód. IBGE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="4" class="text-center text-muted py-3">Carregando...</td>
              </tr>
              <tr v-else-if="logs.length === 0">
                <td colspan="4" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-nowrap">{{ formatarData(log.data_evento) }}</td>
                <td>{{ log.email_usuario }}</td>
                <td>{{ log.nome_municipio ?? '-' }}</td>
                <td>{{ String(log.codigo_siconfi).slice(0, -2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Tabela Uploads -->
      <div v-if="abaAtiva === 'uploads'">
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <thead class="table-light">
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Município</th>
                <th>UF</th>
                <th>Exercício</th>
                <th>Entregável</th>
                <th>Período</th>
                <th>Protocolo</th>
                <th>Extensão</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" class="text-center text-muted py-3">Carregando...</td>
              </tr>
              <tr v-else-if="logs.length === 0">
                <td colspan="9" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-nowrap">{{ formatarData(log.data_evento) }}</td>
                <td>{{ log.email_usuario }}</td>
                <td>{{ log.municipio }}</td>
                <td>{{ log.uf }}</td>
                <td>{{ log.exercicio }}</td>
                <td>
                  <span class="badge bg-secondary">{{ log.entregavel }}</span>
                </td>
                <td>{{ log.periodo }}</td>
                <td><small class="text-muted font-monospace">{{ log.protocolo }}</small></td>
                <td>{{ log.extensao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Tabela Acessos -->
      <div v-if="abaAtiva === 'acessos'">
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <colgroup>
              <col style="width: 10%">
              <col style="width: 20%">
              <col style="width: 25%">
              <col style="width: 10%">
              <col style="width: 10%">
            </colgroup>
            <thead class="table-light">
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Município</th>
                <th>Exercício</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="5" class="text-center text-muted py-3">Carregando...</td>
              </tr>
              <tr v-else-if="logs.length === 0">
                <td colspan="5" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-nowrap">{{ formatarData(log.data_evento) }}</td>
                <td>{{ log.email_usuario }}</td>
                <td>{{ log.nome_municipio }}</td>
                <td>{{ log.exercicio }}</td>
                <td>
                  <span class="badge" :class="log.tipo === 'CAPAG' ? 'bg-primary' : log.tipo === 'BALANCETE' ? 'bg-info text-dark' : 'bg-secondary'">
                    {{ log.tipo == 'SICONFI' ? 'RANKING' : log.tipo }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center gap-2 mt-2">
        <label class="form-label small text-muted mb-0" for="filtro-limite">Exibir</label>
        <select
          id="filtro-limite"
          class="form-select form-select-sm filtro-limite"
          v-model="filtros.limite"
          @change="buscar"
        >
          <option value="25">25 registros</option>
          <option value="50">50 registros</option>
          <option value="100">100 registros</option>
        </select>
      </div>

    </div>

    <!-- Export Progress Overlay -->
    <div v-if="exportProgress.show" class="export-progress-overlay">
      <div class="export-progress-modal">
        <div class="text-center">
          <div
            v-if="!exportProgress.isComplete"
            class="spinner-border text-primary mb-3"
            role="status"
            style="width: 2rem; height: 2rem"
          >
            <span class="visually-hidden">Exportando...</span>
          </div>
          <div v-else class="text-success mb-3">
            <i class="bi bi-check-circle-fill" style="font-size: 2rem;"></i>
          </div>
          <p class="h6 mb-0">{{ exportProgress.message }}</p>
          <small v-if="!exportProgress.isComplete" class="text-muted">
            Esta operação pode levar alguns minutos para grandes volumes de dados
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosApi from "@/axios";
import Nav from "@/components/Nav.vue";
import { mapState, mapActions } from "vuex";

const ENDPOINT_MAP = {
  relatorios: "/api/audit/relatorios",
  balancetes: "/api/audit/balancetes",
  "usuarios-contextos": "/api/audit/usuarios-contextos",
  uploads: "/api/audit/uploads",
  acessos: "/api/audit/acessos",
};

const EXPORT_ENDPOINT_MAP = {
  relatorios: "/api/audit/relatorios/export",
  balancetes: "/api/audit/balancetes/export",
  "usuarios-contextos": "/api/audit/usuarios-contextos/export",
  uploads: "/api/audit/uploads/export",
  acessos: "/api/audit/acessos/export",
};

export default {
  name: "Auditoria",
  components: { Nav },
  data() {
    return {
      abaAtiva: "acessos",
      loading: false,
      logs: [],
      filtros: {
        email: "",
        tipo: "",
        municipio: "",
        de: "",
        ate: "",
        limite: "50",
      },
      isExporting: false,
      exportProgress: {
        show: false,
        message: "Iniciando exportação...",
        isComplete: false,
      },
    };
  },
  computed: {
    ...mapState(["user", "isAuthLoading", "userEntidade"]),
    userAdmin() {
      return this.user && this.user.role === "admin";
    },
  },
  async created() {
    try {
      await this.validateToken();

      const check = () => {
        if (!this.isAuthLoading) {
          if (!this.user || (!this.userAdmin && !this.userEntidade)) {
            this.$router.push("/");
          } else {
            this.buscar();
          }
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    } catch {
      this.$router.push("/login");
    }
  },
  methods: {
    ...mapActions(["validateToken", "showToast"]),
    trocarAba(aba) {
      this.abaAtiva = aba;
      this.logs = [];
      this.filtros.tipo = "";
      this.filtros.municipio = "";
      this.buscar();
    },
    limparFiltros() {
      this.filtros.email = "";
      this.filtros.municipio = "";
      this.filtros.tipo = "";
      this.filtros.de = "";
      this.filtros.ate = "";
      this.buscar();
    },
    async buscar() {
      const abaNoInicio = this.abaAtiva;
      this.loading = true;
      try {
        const params = {
          email: this.filtros.email || undefined,
          de: this.filtros.de || undefined,
          ate: this.filtros.ate || undefined,
          limite: this.filtros.limite,
        };

        if (["relatorios", "acessos"].includes(this.abaAtiva) && this.filtros.tipo) {
          params.tipo = this.filtros.tipo;
        }
        if (this.filtros.municipio) {
          params.municipio = this.filtros.municipio;
        }

        const response = await axiosApi.get(ENDPOINT_MAP[abaNoInicio], { params });
        if (this.abaAtiva !== abaNoInicio) return;
        this.logs = response.data.data || [];
      } catch (error) {
        if (this.abaAtiva !== abaNoInicio) return;
        this.showToast({
          title: "Erro",
          message: "Erro ao carregar logs: " + (error.response?.data?.message || error.message),
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
        this.logs = [];
      } finally {
        this.loading = false;
      }
    },
    async exportarCsv() {
      const abaNoInicio = this.abaAtiva;
      try {
        this.isExporting = true;
        this.exportProgress.show = true;
        this.exportProgress.message = "Iniciando exportação...";
        this.exportProgress.isComplete = false;

        const params = new URLSearchParams();
        if (this.filtros.email) params.append("email", this.filtros.email);
        if (this.filtros.de) params.append("de", this.filtros.de);
        if (this.filtros.ate) params.append("ate", this.filtros.ate);
        if (["relatorios", "acessos"].includes(abaNoInicio) && this.filtros.tipo) {
          params.append("tipo", this.filtros.tipo);
        }
        if (this.filtros.municipio) {
          params.append("municipio", this.filtros.municipio);
        }

        this.exportProgress.message = "Conectando ao servidor...";

        const baseURL = process.env.VUE_APP_BASE_URL;
        const response = await fetch(
          `${baseURL || ""}${EXPORT_ENDPOINT_MAP[abaNoInicio]}?${params}`,
          {
            method: "GET",
            credentials: "include",
            headers: { Accept: "text/csv" },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.exportProgress.message = "Recebendo dados do servidor...";
        const blob = await response.blob();

        this.exportProgress.message = "Preparando download...";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `auditoria_${abaNoInicio}_${new Date().toISOString().slice(0, 10)}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.exportProgress.message = "Download concluído!";
        this.exportProgress.isComplete = true;
        setTimeout(() => {
          this.exportProgress.show = false;
        }, 3000);
      } catch (error) {
        console.error("Error exporting audit logs:", error);
        this.exportProgress.message = "Erro na exportação!";
        this.exportProgress.isComplete = true;
        setTimeout(() => {
          this.exportProgress.show = false;
        }, 5000);
      } finally {
        this.isExporting = false;
      }
    },
    formatarDuracao(ms) {
      if (!ms && ms !== 0) return "-";
      return ms >= 1000 ? (ms / 1000).toFixed(2) + "s" : ms + "ms";
    },
    parsarArray(valor) {
      if (!valor) return [];
      if (Array.isArray(valor)) return valor;
      try { return JSON.parse(valor); } catch { return []; }
    },
    formatarData(iso) {
      if (!iso) return "-";
      /* O banco grava a hora de Brasília com sufixo Z; exibir em UTC evita que o
         navegador subtraia mais 3h na conversão para o fuso local. */
      return new Date(iso).toLocaleString("pt-BR", {
        timeZone: "UTC",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style>
.audit-container {
  min-width: 1200px;
  margin-bottom: 2rem;
}

@media (max-width: 1260px) {
  .audit-container {
    min-width: 0;
    width: 100%;
  }
}

.filtro-email {
  flex: 1 1 200px;
  max-width: 250px;
}

.filtro-municipio {
  flex: 1 1 180px;
  max-width: 230px;
}

.filtro-tipo,
.filtro-data {
  flex: 0 1 150px;
}

.filtro-limite {
  width: 140px;
}

.export-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.export-progress-modal {
  background: white;
  border-radius: var(--radius-md);
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: var(--shadow-lg);
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
